import { XML_AddSingle } from "./XML_AddSingle";
import { Globals } from "../CoreApp/Globals";
export function XML_AddLinkToPPT(linkBookmark, drawElement) {
  if (Globals._accountInfo.GetOC5Edition() == "ADP Basic") return;
  XML_AddSingle(linkBookmark, "lnk", drawElement);
}
